<script lang="ts">
  import { formatDistanceToNow, parseISO, isFuture } from 'date-fns';
  import { showHeaderBanner } from '$lib/stores';

  // Convert from export let to $props()
  const { 
    endDate = undefined,
    title = '',
    description = '',
    buttonText = '',
    buttonLink = ''
  } = $props<{
    endDate?: string;
    title?: string;
    description?: string;
    buttonText?: string;
    buttonLink?: string;
  }>();

  // Use $state for reactive variables
  let timeLeft = $state('');
  let interval = $state<number | undefined>(undefined);

  function updateTimeLeft() {
    // Add null check for endDate
    if (!endDate) {
      showHeaderBanner.set(false);
      return;
    }

    try {
      const parsedDate = parseISO(endDate);
      
      if (isFuture(parsedDate)) {
        timeLeft = formatDistanceToNow(parsedDate, { addSuffix: false });
      } else {
        clearInterval(interval);
        showHeaderBanner.set(false);
      }
    } catch (error) {
      console.error('Date parsing error:', error);
      showHeaderBanner.set(false);
    }
  }

  // Replace onMount with $effect
  $effect(() => {
    if (endDate) {
      updateTimeLeft();
      interval = window.setInterval(updateTimeLeft, 60000);
    } else {
      showHeaderBanner.set(false);
    }

    // Cleanup function
    return () => {
      if (interval) clearInterval(interval);
    };
  });
</script>

{#if $showHeaderBanner && endDate}
  <div class="relative bg-[#1C2535] border-b border-[#2A3447]">
    <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between flex-wrap">
        <div class="w-0 flex-1 flex items-center">
          <span class="flex p-2 rounded-lg bg-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-white">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </span>
          <p class="ml-3 font-medium text-white truncate">
            <span class="md:hidden">{title}</span>
            <span class="hidden md:inline">{title} - {description}</span>
            <span class="font-bold ml-1">{timeLeft} left</span>
          </p>
        </div>
        <div class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
          <a href={buttonLink} class="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-primary bg-white hover:bg-gray-100">
            {buttonText}
          </a>
        </div>
        <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
          <button 
            type="button" 
            class="-mr-1 flex p-2 rounded-md hover:bg-[#2A3447] focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
            on:click={() => showHeaderBanner.set(false)}
            aria-label="Dismiss"
          >
            <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}